<template>
    <div class="login">
        <div class="login-form">
            <a-button type="link" class="back-button" @click="onBack">
                <i class="fa fa-arrow-left fa-6" aria-hidden="true"></i>
            </a-button>

            <h1>Восстановление доступа</h1>

            <p class="subtitle">Введите email, указанный при регистрации</p>

            <!-- Ошибка -->
            <div v-if="errorMessage" class="error-message">
                {{ errorMessage }}
            </div>

            <a-form
                ref="formRef"
                :model="formState"
                :rules="formValidationRules"
                @finish="onSubmit"
            >
                <a-form-item name="email">
                    <a-input
                        v-model:value="formState.email"
                        placeholder="Email"
                        @change="validateEmail"
                    />
                </a-form-item>

                <a-form-item>
                    <a-button
                        type="primary"
                        html-type="submit"
                        :loading="isLoading"
                        :disabled="!isFormValid || isLoading"
                    >
                        Отправить код
                    </a-button>
                </a-form-item>
            </a-form>
        </div>
        <app-version />
    </div>
</template>

<script>
import { showErrorNotification, RouterConfig } from '@/utils';
import AppVersion from '@/components/authorization/AppVersion.vue';

export default {
    name: 'AuthorizationForgotByEmail',
    components: {
        AppVersion,
    },
    data() {
        return {
            formState: {
                email: '',
            },
            formValidationRules: {
                email: [
                    { required: true, message: 'Обязательное поле' },
                    {
                        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: 'Некорректный email',
                    },
                ],
            },
            isLoading: false,
            errorMessage: '',
            isFormValid: false,
        };
    },
    methods: {
        validateEmail() {
            // Проверяем, проходит ли email валидацию
            const { email } = this.formState;
            const required = email && email.trim() !== '';
            const patternValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

            this.isFormValid = required && patternValid;
            this.errorMessage = '';
        },
        async onSubmit() {
            const { deviceId, staffId } = localStorage;

            try {
                this.isLoading = true;
                this.errorMessage = '';

                const response = await this.$http.post('/v2/auth/forgot/init', {
                    email: this.formState.email,
                    deviceId,
                    userId: staffId,
                });

                localStorage[RouterConfig.forgot.name] = JSON.stringify(response.data);

                this.$router.push({ name: RouterConfig.forgotVerify.name });
            } catch (error) {
                if (error.response?.data?.msg) {
                    this.errorMessage = error.response.data.msg;
                } else if (error.response?.data?.message) {
                    this.errorMessage = error.response.data.message;
                } else {
                    showErrorNotification('Не удалось отправить код', 5000);
                }
            } finally {
                this.isLoading = false;
            }
        },
        onBack() {
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
.login {
    background: url("/images/login-wall.jpg") center center / cover no-repeat rgb(255, 255, 255);
    height: 100%;
    display: flex;
}

.login-form {
    position: relative;
    margin: auto;
    max-width: 460px;
    width: 100%;
    border-radius: 8px;
    border: 1px solid #e8e8e8;
    padding: 26px;
    background-color: transparent;
    z-index: 1;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background-color: #fff;
        opacity: 0.8;
        z-index: -1;
    }

    h1 {
        font-size: 26px;
        font-weight: bold;
        margin-bottom: 8px;
        text-align: center;
    }

    .subtitle {
        color: #666;
        font-size: 14px;
        margin-bottom: 8px;
        text-align: center;
        padding: 0 30px;
    }

    .ant-form-item {
        margin-bottom: 18px;
    }

    .ant-form-explain {
        margin-bottom: -17px;
        text-align: left;
        font-size: 13px;
    }

    .error-message {
        color: #ff4d4f;
        font-size: 12px;
        margin-bottom: 15px;
        text-align: left;
        max-width: 100%;
        word-break: break-word;
        white-space: pre-wrap;
        line-height: 1.4;
        padding: 8px 10px;
        background: #fff5f5;
        border: 1px solid #ffccc7;
        border-radius: 4px;
        overflow-x: hidden;
    }

    .login-btn {
        width: 100%;
        height: 40px;
        font-size: 16px;
        margin-bottom: 15px;
    }

    .back-button {
        position: absolute;
        top: 10px;
        left: 10px;
        padding: 0;
        font-size: 16px;

        width: 32px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid #83b274;
        color: #83b274;
        box-shadow: 0 0 0 2px rgb(131, 178, 116, 0.2);

        &:hover {
            color: #74b85d;
            border-color: #74b85d;
            box-shadow: 0 0 0 2px rgba(116, 184, 93, 0.4);
        }
    }

    & .ant-input {
        height: 36px;
        border-radius: 4px;
    }

    .ant-btn.ant-btn-primary {
        min-width: 110px;
        height: auto;
        font-size: 14px;
        margin-top: 18px;

        padding: 7px 20px;
        background-color: #8dc07c;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
        box-shadow: 0px 0px 4px rgba(46, 75, 37, 0.4);
        border: none;
        color: #fff;

        &:disabled,
        &[disabled] {
            pointer-events: none;
            opacity: 0.5;
        }

        &:hover {
            background-color: #74b85d;
        }
    }
}
</style>
